// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39wO0","col":"styles_col__JjnHc"};